export const DELETE_SCENARIO_REQUEST = 'DELETE_SCENARIO_REQUEST';
export const DELETE_SCENARIO_SUCCESS = 'DELETE_SCENARIO_SUCCESS';

export const SCENARIO_CREATE_EMR_TEMPLATE_REQUEST = 'SCENARIO_CREATE_EMR_TEMPLATE_REQUEST';
export const SCENARIO_CREATE_EMR_TEMPLATE_SUCCESS = 'SCENARIO_CREATE_EMR_TEMPLATE_SUCCESS';

export const SCENARIO_CREATE_SCORING_RUBRIC_REQUEST = 'SCENARIO_CREATE_SCORING_RUBRIC_REQUEST';
export const SCENARIO_CREATE_SCORING_RUBRIC_SUCCESS = 'SCENARIO_CREATE_SCORING_RUBRIC_SUCCESS';

export const SCENARIO_DETAIL_REQUEST = 'SCENARIO_DETAIL_REQUEST';
export const SCENARIO_DETAIL_SUCCESS = 'SCENARIO_DETAIL_SUCCESS';

export const SCENARIO_ITEMS_REQUEST = 'SCENARIO_ITEMS_REQUEST';
export const SCENARIO_ITEMS_SUCCESS = 'SCENARIO_ITEMS_SUCCESS';

export const EXPORT_SCENARIO_REQUEST = 'EXPORT_SCENARIO_REQUEST';
export const EXPORT_SCENARIO_SUCCESS = 'EXPORT_SCENARIO_SUCCESS';

export const SCENARIO_HISTORY_REQUEST = 'SCENARIO_HISTORY_REQUEST';
export const SCENARIO_HISTORY_SUCCESS = 'SCENARIO_HISTORY_SUCCESS';

export const UPDATE_SCENARIO_REQUEST = 'UPDATE_SCENARIO_REQUEST';
export const UPDATE_SCENARIO_SUCCESS = 'UPDATE_SCENARIO_SUCCESS';

export const UPDATE_SCENARIO_EVALUATION_TEMPLATE_CONFIG_REQUEST = 'UPDATE_SCENARIO_EVALUATION_TEMPLATE_CONFIG_REQUEST';
export const UPDATE_SCENARIO_EVALUATION_TEMPLATE_CONFIG_SUCCESS = 'UPDATE_SCENARIO_EVALUATION_TEMPLATE_CONFIG_SUCCESS';

export const UPDATE_SCENARIO_VIEWER_REQUEST = 'UPDATE_SCENARIO_VIEWER_REQUEST';
export const UPDATE_SCENARIO_VIEWER_SUCCESS = 'UPDATE_SCENARIO_VIEWER_SUCCESS';

export const UPDATE_SCENARIO_PEOPLE_REQUEST = 'UPDATE_SCENARIO_PEOPLE_REQUEST';
export const UPDATE_SCENARIO_PEOPLE_SUCCESS = 'UPDATE_SCENARIO_PEOPLE_SUCCESS';

export const SCENARIO_CONTRIBUTOR_DEFAULTS_REQUEST = 'SCENARIO_CONTRIBUTOR_DEFAULTS_REQUEST';
export const SCENARIO_CONTRIBUTOR_DEFAULTS_SUCCESS = 'SCENARIO_CONTRIBUTOR_DEFAULTS_SUCCESS';

export const UPDATE_SCENARIO_STATUS_REQUEST = 'UPDATE_SCENARIO_STATUS_REQUEST';
export const UPDATE_SCENARIO_STATUS_SUCCESS = 'UPDATE_SCENARIO_STATUS_SUCCESS';

export const SCENARIO_ORGANIZATIONS_REQUEST = 'SCENARIO_ORGANIZATIONS_REQUEST';
export const SCENARIO_ORGANIZATIONS_SUCCESS = 'SCENARIO_ORGANIZATIONS_SUCCESS';

export const SIMULATORS_REQUEST = 'SCENARIO_DETAIL_SIMULATORS_REQUEST';
export const SIMULATORS_SUCCESS = 'SCENARIO_DETAIL_SIMULATORS_SUCCESS';

export const SET_SCENARIO_SHARING_REQUEST = 'SET_SCENARIO_SHARING_REQUEST';
export const SET_SCENARIO_SHARING_SUCCESS = 'SET_SCENARIO_SHARING_SUCCESS';

export const UPDATE_SCENARIO_ANNOTATION_REQUEST = 'UPDATE_SCENARIO_ANNOTATION_REQUEST';
export const UPDATE_SCENARIO_ANNOTATION_SUCCESS = 'UPDATE_SCENARIO_ANNOTATION_SUCCESS';

export const SCENARIO_USERS_SUCCESS = 'SCENARIO_USERS_SUCCESS';

export const SCENARIO_KEY_ORGANIZATIONS_REQUEST = 'SCENARIO_KEY_ORGANIZATIONS_REQUEST';
export const SCENARIO_KEY_ORGANIZATIONS_SUCCESS = 'SCENARIO_KEY_ORGANIZATIONS_SUCCESS';

export const SCENARIO_USERS_RESET = 'SCENARIO_USERS_RESET';

export const COPY_SCENARIO_REQUEST = 'COPY_SCENARIO_REQUEST';
export const COPY_SCENARIO_SUCCESS = 'COPY_SCENARIO_SUCCESS';

export const GET_SCENARIO_SESSIONS_REQUEST = 'SCENARIO_GET_SCENARIO_SESSIONS_REQUEST';
export const GET_SCENARIO_SESSIONS_SUCCESS = 'SCENARIO_GET_SCENARIO_SESSIONS_SUCCESS';

export const DISPOSE_SCENARIO_DETAIL_STORE = 'DISPOSE_SCENARIO_DETAIL_STORE';
